import React from 'react';

export interface TabsProps {
  /** Array of tab labels */
  tabs: string[];
  /** Currently active tab label */
  activeTab: string;
  /** Callback when a tab is clicked */
  onTabChange: (tab: string) => void;
}

/**
 * A reusable tab navigation component. Renders horizontal tabs with hover and active styling.
 *
 * Tailwind CSS classes assume a dark-themed container (e.g. bg-neutral-900).
 */
export default function Tabs({ tabs, activeTab, onTabChange }: TabsProps) {
  return (
    <div className="flex bg-neutral-900 border-b border-neutral-700">
      {tabs.map((tab) => {
        const isActive = tab === activeTab;
        return (
          <button
            key={tab}
            onClick={() => onTabChange(tab)}
            className={
              `px-4 py-2 text-sm flex-shrink-0
              ${isActive
                ? 'text-neutral-100 font-bold border-b-2 border-white'
                : 'text-neutral-400 hover:text-neutral-100'}
              hover:bg-neutral-800
              transition-colors`
            }
          >
            {tab}
          </button>
        );
      })}
    </div>
  );
}
